import { Button } from 'components/shadcn/button';

type Props = {
  headerText: string;
  buttonText: string;
  onClick: () => void;
};

export function EmptyTableButton({ onClick, headerText, buttonText }: Props) {
  return (
    <div className="w-full gap-4 flex flex-col my-10 justify-center items-center">
      <h3 className="text-balance">{headerText}</h3>
      <Button variant="secondary" onClick={onClick}>
        {buttonText}
      </Button>
    </div>
  );
}
